import http from "../tools/http";

export default {
  update(data) {
    return http.patch("/profile/password", data);
  },
  recovery(email) {
    return http.post("/password-recovery", { email: email.trim() });
  },
  reset(data) {
    return http.post("/password-reset", data);
  }
};
